// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2hyVs","title":"BackImages_title__2ckIB","images":"BackImages_images__1VK5a"};